import Head from 'next/head';
import type { NextPage } from 'next';
import { useRouter } from 'next/router';
import { env } from '@zopauk/nextjs-env';
import { Modules } from '@/components/Modules';
import { renderMetaTags } from 'react-datocms';
import { withSession } from '@zopauk/nextjs-auth';
import { PreviewToast } from '@/components/preview/Toast';
import { useAllPostsQuery } from '@/utils/dato/generated';
import { getServerSideProps, AllPostsModules, AllPostsContext } from '@/utils/models/allPosts/allPosts';

const AllPosts: NextPage<AllPostsContext> = (context) => {
  const { query } = useRouter();
  const { data } = useAllPostsQuery({ perPage: context.pagination.perPage, skip: context.pagination.skip });

  const page = Array.isArray(query.page) ? query.page[0] : query.page;

  const isPaginated = page && page !== '1';

  const canonical = `${env('NEXT_PUBLIC_WEB_GALLERIA_URL')}/blog${isPaginated ? `?page=${page}` : ''}`;

  const baseTitle = data?.template?.seo?.find((tag) => tag.tag === 'title')?.content || 'Zopa Blog';

  const paginatedTitle = isPaginated ? `${baseTitle} - Page ${page}` : baseTitle;

  return (
    <>
      <Head>
        {data?.template?.seo ? renderMetaTags(data.template.seo.concat(data.site.favicon)) : null}
        <title>{paginatedTitle}</title>
        <link href={canonical} rel="canonical" />
      </Head>
      {data?.template?.modular ? (
        <Modules<AllPostsModules, AllPostsContext> modules={data.template.modular} context={context} />
      ) : null}
      <PreviewToast />
    </>
  );
};

export { getServerSideProps };

export default withSession(AllPosts, { forceLogin: false });
